
import { Component, Prop, Vue } from 'vue-property-decorator'

const directionValidator = (value) => {
  // The value must match one of these strings
  return ['up', 'down', 'left', 'right'].includes(value);
}

@Component({
  components: {
  }
})
export default class ArrowSvg extends Vue {
  @Prop({ type: String, default: 'arrow-svg' }) name: string;
  @Prop({ type: String, validator: directionValidator, default: 'down' }) position: string;
  @Prop({ type: String, validator: directionValidator, default: 'up' }) active: string;
  @Prop({ type: [Number, String], default: 14 }) width;
  @Prop({ type: [Number, String], default: 14 }) height;

  get iconStyle() {
    const { width, height } = this;
    return {
      width: `${width}px`,
      height: `${height}px`
    };
  }

  get classes() {
    return {
      down: this.position === 'down',
      up: this.position === 'up',
      left: this.position === 'left',
      right: this.position === 'right',
      'down-active': this.active === 'down',
      'up-active': this.active === 'up',
      'left-active': this.active === 'left',
      'right-active': this.active === 'right',
    }
  }
}
